export function lightbox() {
    (function() {
        /**
         * Simple Image Lightbox
         * Reuses a single Bootstrap modal to display an image at full size.
         *
         * Opt in per image with `data-lightbox`. Optional attributes:
         *   data-lightbox-src     — larger image to show in the modal (falls back to the img src)
         *   data-lightbox-caption — caption text (falls back to the figure's figcaption)
         */
        const modalEl = document.getElementById('imageLightbox');
        if (!modalEl) return;

        const modal = new bootstrap.Modal(modalEl);
        const $image = $(modalEl).find('.lightbox-image');
        const $caption = $(modalEl).find('.lightbox-caption');

        // Bootstrap only restores focus for modals opened via data-bs-toggle,
        // so we track the trigger and send the keyboard back there on close
        let $lastTrigger = null;

        // An <img> can't take focus or fire a click from the keyboard, so give
        // each trigger the semantics of the button it already behaves like
        const $triggers = $('[data-lightbox]')
            .css('cursor', 'zoom-in')
            .attr('tabindex', '0')
            .attr('role', 'button');

        // role="button" drops the alt text as the accessible name, so fold it
        // into a label that says what activating the image will do
        $triggers.each(function() {
            const $img = $(this);
            if ($img.attr('aria-label')) return;

            const alt = ($img.attr('alt') || '').trim();
            $img.attr('aria-label', alt ? 'View larger image: ' + alt : 'View larger image');
        });

        $triggers.on('keydown', function(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault(); // Space would otherwise scroll the page
            $(this).trigger('click');
        });

        $triggers.on('click', function() {
            const $img = $(this);
            const largeSrc = $img.data('lightbox-src') || $img.attr('src');
            const caption = ($img.data('lightbox-caption')
                || $img.closest('figure').find('figcaption').text()
                || '').trim();

            $image.attr('src', largeSrc).attr('alt', $img.attr('alt') || '');
            $caption.text(caption).toggle(caption.length > 0);
            $lastTrigger = $img;
            modal.show();
        });

        modalEl.addEventListener('hidden.bs.modal', function() {
            // Drop the source so a stale image never flashes on reopen
            $image.attr('src', '');

            if ($lastTrigger && $lastTrigger.is(':visible')) {
                $lastTrigger.trigger('focus');
            }
            $lastTrigger = null;
        });
    })();
}
